// src/utils/logger.js
const isProd = import.meta.env.PROD;

function getCallerInfo() {
  const err = new Error();
  const stack = err.stack?.split("\n");
  // stack[0] = "Error"
  // stack[1] = inside getCallerInfo()
  // stack[2] = inside our logger
  // stack[3] = actual caller
  return stack?.[3]?.replace("at ", "").trim() || "unknown";
}

const logger = {
  log: (...args) => {
    if (!isProd) {
      console.log("%c[LOG]", "color: green", getCallerInfo(), ...args);
    }
  },
  info: (...args) => {
    if (!isProd) {
      console.info("%c[INFO]", "color: blue", getCallerInfo(), ...args);
    }
  },
  warn: (...args) => {
    if (!isProd) {
      console.warn("%c[WARN]", "color: orange", getCallerInfo(), ...args);
    }
  },
  error: (...args) => {
    // errors should always log, even in prod
    console.error("%c[ERROR]", "color: red", getCallerInfo(), ...args);
  }
};

export default logger;
